import { useState, useEffect } from "react"

export function useDeviceType(customBreakpoint) {
  const [width, setWidth] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : null
  )
  useEffect(() => {
    setWidth(window.innerWidth)
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const isMobile = width < 768
  const isTablet = width >= 768 && width < 1024
  const isDesktop = width >= 1024
  // Custom breakpoint logic (optional)
  const isBelow = customBreakpoint !== undefined && width < customBreakpoint
  const isAbove = customBreakpoint !== undefined && width >= customBreakpoint
  return {
    width,
    isMobile,
    isTablet,
    isDesktop,
    // custom (only valid if breakpoint passed)
    isBelow,
    isAbove,
  }
}
